import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import UserLink from '../../../User/Link';
import s from './DailyDev.scss';
export var DailyDevInfo = function (_a) {
    var _b = _a.dailyDeviation, body = _b.body, giver = _b.giver, className = _a.className;
    return (React.createElement("div", { className: classnames(s['dd-info'], className) },
        React.createElement("div", { className: s['dd-text'], dangerouslySetInnerHTML: {
                __html: body,
            } }),
        giver && (React.createElement("div", { className: s['dd-featured'] },
            React.createElement(Trans, { i18nKey: "deviationview.dailydev.featuredby" },
                "Featured By ",
                React.createElement(UserLink, { className: s['dd-giver'], user: giver }))))));
};
DailyDevInfo.displayName = 'DailyDevInfo';
export default DailyDevInfo;
//# sourceMappingURL=DailyDevInfo.js.map